/**
 * Allowed CTA / link URLs for storefront slices and aisle content modules
 * (banners, carousels, product spotlights).
 *
 * Permits MM/IF domains (with subdomains), Instagram/Facebook/TikTok,
 * relative /shop and /account paths, and hash links.
 */
export const CONTENT_LINK_URL_PATTERN =
    '^(https:\\/\\/([a-zA-Z0-9]+\\.)?(misfitsmarket\\.com|imperfectfoods\\.com|instagram\\.com|facebook\\.com|tiktok\\.com)|\\/(shop|account)|#.*)([\\/?#].*)?$';

export const CONTENT_LINK_URL_TITLE =
    'Must be a URL starting with https://misfitsmarket.com, https://imperfectfoods.com, https://instagram.com, https://facebook.com, or https://tiktok.com (subdomains allowed), /shop or /account, or a hash link starting with #';
